import { fmtEur } from '../formatArcaNumbers';

/**
 * «+9,84 %» / «-3,20 %»: con el signo siempre, porque es una variación, y siempre dos decimales,
 * como Caser (decisión de Marisa, 20/10/2026): con uno, dos cifras que difieren en el segundo
 * parecían la misma o un error de redondeo.
 */
export const fmtPorcentaje = (porcentaje: number, language: string) => {
	const cifra = Math.abs(porcentaje).toLocaleString(language === 'en' ? 'en-US' : 'es-ES', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	});
	// El signo, el de la cifra que se ve: lo que redondea a 0 (y el -0) es «+0,00 %», no
	// «-0,00 %» (la card pintaría en naranja una pérdida que no se ve).
	const seVeUnCero = /^[0.,]+$/.test(cifra);
	return `${porcentaje < 0 && !seVeUnCero ? '-' : '+'}${cifra} %`;
};

/** «+150,00€» / «-400,00€»: lo que entra y lo que sale, con su signo. */
export const fmtImporteConSigno = (importe: number) =>
	`${importe >= 0 ? '+' : '-'}${fmtEur(Math.abs(importe))}`;

const ANIO_DE_MADRID = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', year: 'numeric' });

/**
 * El año en curso en España, el mismo que usa comparsa para el saldo a 1 de enero: con un
 * navegador en otra zona (Canarias, fuera de España), `getFullYear` cambiaría de año a otra hora.
 */
export const anioDeMadrid = (fecha: Date): number => Number(ANIO_DE_MADRID.format(fecha));
